@if (device) {
  @if (device.latitude !== undefined) {
    <navigation-card (navigate)="goTo(d)">
      <div class="device-card__row">
        @if (display === 'error') {
          <div>
            @if (device.isPrivacy) {
              <mat-icon class="devicecard-error-warning-widget">lock</mat-icon>
            } @else if (device.anomalyError) {
              <mat-icon
                class="devicecard-error-warning-widget"
                [matTooltip]="'DEVICE.' + device.anomalyError | translate">
                {{ device.anomalyError === 'GPS_ANOMALY' ? 'gps_off' : 'portable_wifi_off' }}
              </mat-icon>
            }
          </div>
        }
        @if (device.hasBeacon) {
          <mat-icon class="device-card__beacon-icon">mode_standby</mat-icon>
        } @else {
          <span [class]="(device.isPrivacy ? 'inactive-device ' : '') + device.deviceStatusClass"></span>
        }
        <div class="device-card__info">
          <span>{{ device.registration }}</span>

          @if ($devicesMap()) {
            @if (!device.poi || !$landmarksById() || !$landmarksById()[device.poi]) {
              <p class="device-card__address">
                {{ device.address }}
                @if (!!device.uid_zoi && $landmarksById()[device.uid_zoi]) {
                  <span>({{ $landmarksById()[device.uid_zoi].label }})</span>
                }
              </p>
            }
            @if (device.poi && $landmarksById() && $landmarksById()[device.poi]) {
              <div class="device-card-poi-info">
                <span
                  class="device-poi poi_item poi_{{
                    $landmarksById()[device.poi].icon
                  }} marg-right-five"></span>
                <p class="device-card__address">
                  {{ $landmarksById()[device.poi].label }}
                  @if (!!device.uid_zoi && $landmarksById()[device.uid_zoi]) {
                    <span>({{ $landmarksById()[device.uid_zoi].label }})</span>
                  }
                </p>
              </div>
            }
            @if (isDisplayDriver && device.uid_driver && $drivers()?.[device?.uid_driver]) {
              <div class="device-card-poi-info">
                <p class="device-card__info container-driver-info">
                  <mat-icon class="icon-driver-info">record_voice_over</mat-icon>
                  {{ $drivers()?.[device.uid_driver].label }}
                </p>
              </div>
            }
          }
        </div>
        <div class="date">
          @switch (display) {
            @case ('keywords') {
              <div>
                @if (distance === undefined && mapService.$displayRoute() === false) {
                  <div class="deviceCard-inlineKeywords">
                    @for (d of device.keywordList; track d) {
                      <div>
                        @if ($index === 0 && $keywords()[d]) {
                          <p class="detail-keyword keywordsArray-max">
                            {{ $keywords()[d].label }}
                          </p>
                        }
                      </div>
                    }
                    <div>
                      @if (device.keywordList && device.keywordList.length >= 2) {
                        <p class="detail-keyword keywordsArray-max">...</p>
                      }
                    </div>
                  </div>
                }
                @if (!distance && device.location_date && device.gps_sat_used >= 3 && !device.anomalyError) {
                  <span
                    [class]="
                      display === 'keywords' && device?.keywordList?.length > 0
                        ? 'devicecard-container-date'
                        : 'date-devicecard'
                    ">
                    {{ device.location_date * 1000 | dynamicDate: 'short' }}
                  </span>
                }
              </div>
            }
            @case ('realDistance') {
              <div>
                @if (
                  distance !== undefined &&
                  mapService.$realClosest()[d] !== undefined &&
                  mapService.$displayRoute() === true
                ) {
                  <span class="approx-distance">
                    {{ mapService.$realClosest()[d].realDistance | imperial: 'distance' : 2 }}
                  </span>
                }
              </div>
            }
            @case ('beacon') {
              <div style="display: flex; flex-direction: column">
                @if (distance !== undefined) {
                  <span class="approx-distance">~ {{ distance | imperial: 'distance' : 2 }}</span>
                }
                @if (device.location_date) {
                  <span class="approx-distance">
                    {{ device.location_date * 1000 | dynamicDate: 'short' }}
                  </span>
                }
              </div>
            }
            @case ('distance') {
              <div>
                @if (display === 'distance' && distance !== undefined) {
                  <span class="approx-distance">~ {{ distance | imperial: 'distance' : 2 }}</span>
                }
              </div>
            }
            @case ('triplessTime') {
              <div>
                <div>
                  <p class="devicecard-time">{{ time }} {{ 'DATE.DAY' | translate | lowercase }}</p>
                </div>
              </div>
            }
            @case ('private') {
              <div>
                <p class="devicecard-time">{{ time | duration }}</p>
                <p></p>
              </div>
            }
            @case ('locked') {
              <i class="material-icons widget-locked-icon">lock</i>
            }
            @default {
              <div></div>
            }
          }
        </div>
      </div>
    </navigation-card>
  } @else {
    <div [class]="device.latitude === undefined ? 'dmic-list-li dmic-list-li-hofo' : 'dmic-list-li'">
      @if (device.latitude === undefined) {
        <div class="list_item anim_onetime">
          <span class="status_img device_1 inactive-device"></span>
          <div>
            <span class="registration">
              {{ device.registration }}
              <small>{{ device.driver_name }}</small>
            </span>
            @if (d) {
              <span class="driver_name">{{ 'DEVICE.STATUS.INACTIVE' | translate }}</span>
            }
          </div>
          <div class="date"></div>
        </div>
      }
    </div>
  }
}
